import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ProjectCard } from './ProjectCard';
export function ProjectsGallery() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const projects = [{
    title: 'Gold Prices Analysis',
    description: "Daily-tracking tool analyzing Egypt's gold prices in EGP to help investors understand market trends and their connection to global movements.",
    technologies: ['Python', 'Data cleaning', 'Data preprocessing', 'Power BI', 'Excel'],
    color: 'teal' as const,
    githubLink: 'https://github.com/danaelshrbiny10/Gold-Prices.git'
  }, {
    title: 'EV Charging Analytics Dashboard',
    description: 'Real-time dashboard tracking charging station performance, usage patterns, and network optimization metrics across Egypt.',
    technologies: ['Web Scraping', 'Excel', 'Looker Studio', 'MySQL', 'Python'],
    color: 'orange' as const
    // No link for sensitive real-time project
  }, {
    title: 'Habit Tracker',
    description: 'Streamlit app predicting daily mood from lifestyle metrics for personalized insights.',
    technologies: ['Python', 'Pandas', 'Matplotlib', 'Streamlit'],
    color: 'purple' as const,
    githubLink: 'https://github.com/danaelshrbiny10/Habit-Tracker.git'
  }];
  return <section ref={ref} className="w-full py-24 px-6 bg-slate-900" id="projects" data-id="element-124">
      <div className="max-w-7xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-126">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-slate-100" data-id="element-127">
            Featured Projects
          </h2>
          <p className="text-lg text-slate-400 font-mono" data-id="element-128">
            {'>'} Real-world applications of data analytics
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-129">
          {projects.map((project, index) => <ProjectCard key={project.title} title={project.title} description={project.description} technologies={project.technologies} color={project.color} githubLink={project.githubLink} delay={index * 0.1} data-id="element-130" />)}
        </div>
      </div>
    </section>;
}